<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div class="cart-box">
    <s-header :name="'申请发票'" :back="'/user'"></s-header>
    <div class="cart-body">
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        class="order-list-refresh"
      >
        <van-list
          v-model:loading="loading"
          :finished="finished"
          @load="onLoad"
          @offset="50"
        >
          <van-checkbox-group
            @change="groupChange"
            v-model="result"
            ref="checkboxGroup"
          >
            <van-swipe-cell
              :right-width="50"
              v-for="(item, index) in list"
              :key="index"
            >
              <van-checkbox :name="item.orderNo" />
              <div>
                <div
                  style="
                    padding-left: 10px;
                    justify-content: space-between;
                    display: flex;
                  "
                >
                  <span>订单时间：{{ item.createTime }}</span>
                  <span>交易完成</span>
                </div>
                <div
                  class="good-item"
                  v-for="(ele, index) in item.newBeeMallOrderItemVOS"
                  :key="index * 2"
                >
                  <div class="good-img">
                    <img :src="$filters.prefix(ele.goodsCoverImg)" alt="" />
                  </div>
                  <div class="good-desc">
                    <div class="good-title">
                      <span>{{ ele.goodsName }}</span>
                      <span>x{{ ele.goodsCount }}</span>
                    </div>
                    <div class="good-remarks">
                      <span>全场包邮</span>
                    </div>
                    <div class="good-btn"></div>
                  </div>
                </div>
                <div class="price">¥{{ item.payPrice }}</div>

                <van-button
                  v-if="item.newBeeMallOrderItemVOS[0].sellingPrice > 0"
                  round
                  size="mini"
                  color="#40c6ff"
                  class="listbutton"
                  type="primary"
                  @click="goTo(item)"
                  >申请开票</van-button
                >
              </div>
            </van-swipe-cell>
            <div></div>
          </van-checkbox-group>
        </van-list>
      </van-pull-refresh>
      <p
        style="
          color: #969799;
          font-size: 14px;
          line-height: 30px;
          text-align: center;
        "
      >
        仅显示一年订单<br />若您有开票的订单不在开票列表，可尝试上拉加载<br />如有疑问，请联系400-801-3838
      </p>
    </div>

    <van-submit-bar
      v-if="list.length > 0"
      class="submit-all van-hairline--top"
      :price="total * 100"
      button-color="#40c6ff"
      button-text="申请开票"
      @submit="onSubmit"
    >
      <van-checkbox @click="allCheck" v-model:checked="checkAll"
        >全选</van-checkbox
      >
    </van-submit-bar>
    <div class="empty" v-if="!list">
      <img
        class="empty-cart"
        src="https://s.yezgea02.com/1604028375097/empty-car.png"
        alt="空购物车"
      />
      <div class="title">当前没有可开票的订单</div>
      <van-button round color="#40c6ff" type="primary" @click="goTo" block
        >前往选购</van-button
      >
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, computed, toRefs } from 'vue'
import { useRouter } from 'vue-router'
// import { useStore } from 'vuex'
import { Toast } from 'vant'
import sHeader from '@/components/SimpleHeader'
import { getuserinvoice } from '@/service/apply'
import { removeLocal } from '@/common/js/utils'
export default {
  components: {
    sHeader
  },
  setup() {
    const router = useRouter()
    const state = reactive({
      loading: false,
      finished: false,
      refreshing: false,
      checked: false,
      list: [],
      all: false,
      result: [],
      productid: [],
      checkAll: false,
      page: 1,
      totalPage: 0,
      invoiceOrderInfos: []
    })

    onMounted(() => {
      onRefresh()
      removeLocal('taxNo')
      removeLocal('company')
      removeLocal('fromData')
    })
    const loadData = async () => {
      const {
        data,
        data: { list }
      } = await getuserinvoice({ pageNumber: state.page })
      state.list = state.list.concat(list)
      state.totalPage = data.totalPage
      state.loading = false
      if (state.page >= data.totalPage) state.finished = true
    }

    const onLoad = () => {
      console.log(state.page, state.totalPage)
      if (!state.refreshing && state.page < state.totalPage) {
        state.page = state.page + 1
      }
      if (state.refreshing) {
        state.list = []
        state.refreshing = false
      }
      loadData()
    }

    const onRefresh = () => {
      state.refreshing = true
      // 清空列表数据
      state.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      state.loading = true
      state.page = 1
      onLoad()
    }
    const total = computed(() => {
      let sum = 0
      let thesum = 0
      let _list = state.list.filter((item) =>
        state.result.includes(item.orderNo)
      )
      state.invoiceOrderInfos = _list.map((item) => {
        return {
          orderNo: item.orderNo,
          goodsIds: item.newBeeMallOrderItemVOS.map((ele) => {
            return ele.goodsId
          })
        }
      })
      state.productid = []
      _list.forEach((item) => {
        state.productid.push(item.newBeeMallOrderItemVOS)
        // item.newBeeMallOrderItemVOS.forEach(() => {
        sum += item.payPrice
        // })
      })
      thesum += sum
      return thesum
    })

    const goTo = (data) => {
      let sum = 0
      var thesum = 0
      state.invoiceOrderInfos = [data].map((item) => {
        return {
          orderNo: item.orderNo,
          goodsIds: item.newBeeMallOrderItemVOS.map((ele) => {
            return ele.goodsId
          })
        }
      })
      if (data.newBeeMallOrderItemVOS.length > 1) {
        // data.newBeeMallOrderItemVOS.forEach(() => {
        sum += data.payPrice
        // })
        thesum = sum
      } else {
        thesum = data.payPrice
      }
      const params = JSON.stringify(state.invoiceOrderInfos)
      router.push({
        path: '/Applyinput',
        query: {
          price: thesum,
          invoiceOrderInfos: params
        }
      })
    }

    const onSubmit = async () => {
      if (state.result.length == 0) {
        Toast.fail('请选择订单进行开票')
        return
      }
      // const order = []
      // state.productid.forEach((item) => {
      //   item.forEach((b) => {
      //     order.push(b.goodsId)
      //   })
      // })
      const params = JSON.stringify(state.invoiceOrderInfos)

      router.push({
        path: '/Applyinput',
        query: {
          price: total.value,
          invoiceOrderInfos: params
        }
      })
    }

    //复选框
    const groupChange = (result) => {
      if (result.length == state.list.length) {
        state.checkAll = true
      } else {
        state.checkAll = false
      }
      state.result = result
    }

    const allCheck = () => {
      if (!state.checkAll) {
        state.result = state.list.map((item) => item.orderNo)
      } else {
        state.result = []
      }
    }

    return {
      ...toRefs(state),
      total,
      onLoad,
      onRefresh,
      goTo,
      onSubmit,
      groupChange,
      allCheck
    }
  }
}
</script>

<style lang="less" scoped>
@import '../common/style/mixin';
.router-view {
  background: #f9f9f9;
}
.listbutton {
  width: 40%;
  float: right;
}
.cart-box {
  .cart-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    .fj();
    .wh(100%, 44px);
    line-height: 44px;
    padding: 0 10px;
    .boxSizing();
    color: #252525;
    background: #fff;
    border-bottom: 1px solid #efefef;
    .cart-name {
      font-size: 14px;
    }
  }
  .cart-body {
    padding: 10px 10px 60px 10px;
    position: relative;
    background: #ffffff;
    height: calc(~'(100vh - 100px)');
    padding: 10px 20px;
    overflow: auto;
    // .content {
    //   height: calc(~'(100vh - 55px)');
    //   overflow: hidden;
    //   overflow-y: scroll;
    // }
    .van-swipe-cell {
      position: relative;
      margin-bottom: 10px;
      .van-checkbox {
        position: absolute;
        top: 50%;
      }
    }
    .good-item {
      padding: 10px 10px 10px 30px;
      display: flex;
      .good-img {
        margin-left: 10px;
        img {
          .wh(80px, 80px);
        }
      }
      .good-desc {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        padding: 0px 5px;
        .good-title {
          font-size: 14px;
          display: flex;
          justify-content: space-between;
        }
        .good-btn {
          display: flex;
          justify-content: space-between;
          .van-icon-delete {
            font-size: 20px;
            margin-top: 4px;
          }
        }
      }
    }
    .price {
      position: absolute;
      right: 0;
      bottom: 25px;
      font-size: 14px;
      color: red;
      line-height: 28px;
    }

    .delete-button {
      width: 50px;
      height: 100%;
      background: #fff;
      color: red;
      border: none;
    }
  }
  .empty {
    width: 50%;
    margin: 0 auto;
    text-align: center;
    margin-top: 200px;
    .empty-cart {
      width: 150px;
      margin-bottom: 20px;
    }
    .van-icon-smile-o {
      font-size: 50px;
    }
    .title {
      font-size: 16px;
      margin-bottom: 20px;
    }
  }
  .submit-all {
    .van-checkbox {
      margin-left: 10px;
    }
    .van-submit-bar__text {
      margin-right: 10px;
    }
    .van-submit-bar__button {
      background: @primary;
    }
  }

  .van-checkbox__icon--checked .van-icon {
    background-color: @primary;
    border-color: @primary;
  }
}
</style>
